export default __webpack_public_path__ + "static/media/AR-pos.1107d8b1.svg";